// Textos da landing page. A LP é PT-BR apenas: o dicionário existe para
// manter a copy fora do JSX, não para internacionalização.
export const t = {
  header: {
    nav: {
      about: "A Fidexa",
      security: "Segurança",
      products: "Produtos",
      materials: "Materiais",
      press: "Newsroom",
    },
    login: "Entrar",
    menu: "Abrir menu",
    specialistShort: "Especialista",
    specialist: "Fale com um especialista",
  },
  hero: {
    title: "Sistema de cobrança automatizado via WhatsApp para o seu crediário.",
    subtitle:
      "A Fidexa automatiza a cobrança recorrente das parcelas, recupera inadimplentes e reduz a inadimplência da sua loja de forma eficiente, amigável e em conformidade.",
    cta: "Ver quanto minha loja pode recuperar",
    ctaNote: "Demonstração gratuita com um especialista",
    paymentsCard: {
      caption:
        "Exemplo ilustrativo: parcelas pagas pelos clientes chegando uma a uma e o valor recuperado pela loja subindo.",
      label: "Recuperado pela sua loja",
      hint: "recebido este mês · exemplo ilustrativo",
      badge: "automático",
    },
  },
  recovered: {
    srLabel: "R$ 39,4 milhões já recuperados pela Fidexa",
    line1: "Milhões já recuperados",
    line2: "pela Fidexa",
  },
  press: {
    eyebrow: "Fidexa na mídia",
    title: "O que a imprensa está falando sobre a Fidexa",
    subtitle:
      "Veículos de negócios e varejo acompanham a nossa trajetória na recuperação de crediário.",
    readMore: "Ler matéria",
    highlight: "Fidexa ajuda a recuperar R$ 39,4M para PMEs no varejo",
    items: [
      {
        outlet: "PEGN",
        date: "Agosto de 2026",
        title:
          "Eles fundaram uma startup que automatiza cobrança de crediário do varejo e já recuperaram R$ 39,4 milhões",
        excerpt:
          "Em menos de um ano de operação, a Fidexa atingiu breakeven e gera caixa.",
        logoAlt: "PEGN — Pequenas Empresas & Grandes Negócios",
      },
      {
        outlet: "Novo Varejo",
        date: "Agosto de 2026",
        title:
          "Fintech Fidexa de cobrança no varejo atrai empresário que levantou US$ 130 milhões em rodadas internacionais",
        excerpt:
          "A Fidexa recuperou R$ 39,34 milhões para lojistas do varejo, atingiu breakeven e lança solução para clientes com o ERP da TOTVS Linx.",
        logoAlt: "Novo Varejo",
      },
      {
        outlet: "Portal ERP",
        date: "Agosto de 2026",
        title:
          "Fidexa integra IA e WhatsApp ao ERP da TOTVS Linx para automatizar cobrança no varejo",
        excerpt:
          "A fintech lança o Fidexa Pay para conectar gestão de recebíveis, negociação de débitos e pagamentos via Pix à operação dos lojistas.",
        logoAlt: "Portal ERP",
      },
      {
        outlet: "NOVAREJO",
        date: "Setembro de 2026",
        title:
          "Fidexa: a startup que ajuda lojas a recuperar dívidas com WhatsApp",
        excerpt:
          "Com inteligência artificial e WhatsApp, a Fidexa ajuda pequenas lojas de calçados e roupas a recuperar dívidas a partir de R$ 50.",
        logoAlt: "NOVAREJO — Portal No Varejo",
      },
      {
        outlet: "Baguete",
        date: "Setembro de 2026",
        title: "Fidexa vai atrás de pequenos devedores",
        excerpt:
          "Contas não pagas de R$ 50 no varejo estão na mira da startup, que já recuperou R$ 39,34 milhões para os lojistas.",
        logoAlt: "Baguete",
      },
    ],
  },
  successStories: {
    eyebrow: "Caso de sucesso",
    cta: "Quero resultados como esses",
    prevAriaLabel: "Depoimento anterior",
    nextAriaLabel: "Próximo depoimento",
    items: [
      {
        headline:
          "Inadimplência reduzida de 14% para 8% com cobranças via WhatsApp.",
        quote:
          "Com mensagens automáticas e personalizadas, o time financeiro conseguiu recuperar clientes e reduzir atrasos sem aumentar custos operacionais.",
        logo: "/landing-page/partners/lojas-elder-cliente-fidexa.png",
        logoAlt: "Lojas Elder",
        name: "",
        role: "",
      },
      {
        headline: "Foi como ganhar um funcionário sem aumentar custos.",
        quote:
          "Antes a cobrança era manual, cheia de planilha e mensagem perdida no WhatsApp. Hoje o sistema roda sozinho, e minha equipe saiu de um trabalho operacional para focar em atendimento e vendas. Foi como ganhar um funcionário sem aumentar custos. Além disso, hoje utilizamos a Fidexa como canal oficial de cobrança da loja, centralizando toda a comunicação e garantindo mais controle e eficiência no processo.",
        logo: "/landing-page/partners/espaco-vip-cliente-fidexa.png",
        logoAlt: "Espaço Vip",
        name: "Welton Braga",
        role: "Gestor Administrativo da Loja Espaço Vip",
      },
    ],
  },
  solutions: {
    srHeading:
      "Soluções da Fidexa para cobrança via WhatsApp e gestão de crediário",
    interestCard: {
      caption:
        "Exemplo ilustrativo: juros recebidos pela loja em 30, 60 e 90 dias, com o gráfico de recebimentos subindo ao longo do período.",
      title: "Juros recebidos",
      days: "dias",
    },
    chatsCard: {
      caption:
        "Exemplo ilustrativo: mensagens de clientes de lojas diferentes chegando, uma a uma, no mesmo chat da Fidexa.",
      customer: "Cliente",
      store: "Loja",
    },
    messagesCard: {
      caption:
        "Exemplo ilustrativo: um disparo de mensagens de cobrança em andamento, com o contador de enviadas subindo até concluir.",
      title: "Envio de mensagens",
      sent: "Enviadas",
      progress: "Progresso do envio",
      processing: "Processando",
      done: "Concluído",
    },
    items: [
      {
        title: "Cobrança automatizada",
        description:
          "Sistema de cobrança de inadimplentes com disparos automáticos via WhatsApp: a régua cobra cada parcela do crediário no dia certo, sem trabalho manual.",
      },
      {
        title: "Chats Unificados",
        description:
          "Controle múltiplos números de WhatsApp em um único chat unificado, facilitando o atendimento.",
      },
      {
        title: "Análise de Conversão",
        description:
          "Monitore e avalie o desempenho das cobranças para aumentar a taxa de sucesso e otimizar resultados.",
      },
    ],
  },
  // Visuais animados das soluções e demo de cobrança (componentes em
  // src/pages/landingPage/components/). Exemplo ilustrativo: nomes, lojas e
  // valores fictícios, sem relação com cliente real.
  solutionVisuals: {
    billing: {
      ariaLabel:
        "Exemplo ilustrativo: painel de disparos de cobrança pelo WhatsApp, com cada mensagem passando de agendada a enviada, entregue, lida e paga.",
      title: "Disparos de hoje",
      live: "Ao vivo",
      paused: "Pausado",
      sent: "Enviadas",
      read: "Lidas",
      paid: "Pagas",
      status: {
        scheduled: "Agendada",
        sending: "Enviando",
        delivered: "Entregue",
        read: "Lida",
        paid: "Paga",
      },
      rows: [
        { name: "Juliana Santos", detail: "Parcela 3 de 6 · R$ 189,90" },
        { name: "Carlos Moreira", detail: "Parcela 2 de 4 · R$ 254,30" },
        { name: "Fernanda Lima", detail: "Parcela 5 de 10 · R$ 98,70" },
        { name: "Roberto Faria", detail: "Parcela 1 de 3 · R$ 412,50" },
        { name: "Ana Paula Rocha", detail: "Parcela 4 de 6 · R$ 129,90" },
      ],
    },
    chats: {
      ariaLabel:
        "Exemplo ilustrativo: caixa de entrada única com conversas de clientes de três lojas, que sobem ao topo quando chega mensagem nova.",
      title: "Conversas",
      unread: "não lidas",
      store: "Loja",
      all: "Todas",
      contacts: [
        {
          id: 1,
          name: "Juliana Santos",
          store: 2,
          preview: "Vou sábado na loja, esqueci de pagar.",
          time: "09:12",
          unread: 1,
        },
        {
          id: 2,
          name: "Marcos Teixeira",
          store: 1,
          preview: "Acabei esquecendo de pagar, me manda o Pix?",
          time: "09:05",
          unread: 0,
        },
        {
          id: 3,
          name: "Fernanda Lima",
          store: 3,
          preview: "Obrigada por me lembrar, já efetuei o pagamento.",
          time: "08:47",
          unread: 0,
        },
        {
          id: 4,
          name: "Roberto Faria",
          store: 1,
          preview: "Posso dividir a parcela em duas vezes?",
          time: "08:30",
          unread: 2,
        },
        {
          id: 5,
          name: "Ana Paula Rocha",
          store: 2,
          preview: "Me manda o boleto atualizado, por favor.",
          time: "08:12",
          unread: 0,
        },
      ],
      incoming: [
        { id: 3, text: "Paguei agora pelo link, pode conferir?" },
        { id: 5, text: "Consigo pagar na sexta?" },
        { id: 2, text: "Pronto, pago!" },
        { id: 4, text: "Fechado, pode mandar o acordo." },
      ],
    },
    conversion: {
      ariaLabel:
        "Exemplo ilustrativo: painel de análise de conversão com a taxa de recuperação, os juros recebidos e a recuperação de cada faixa da régua em 30, 60 e 90 dias.",
      title: "Análise de conversão",
      periodLabel: "Período",
      days: "dias",
      interest: "Juros recebidos",
      recovered: "recuperado",
      byRange: "Recuperação por faixa",
      ranges: [
        "Antes do vencimento",
        "1 a 5 dias de atraso",
        "6 a 15 dias de atraso",
        "Mais de 15 dias de atraso",
      ],
      periods: [
        { days: 30, rate: 21.4, interest: 2874.3, ranges: [64, 41, 23, 9] },
        { days: 60, rate: 27.8, interest: 5391.12, ranges: [68, 47, 29, 14] },
        { days: 90, rate: 32.1, interest: 8213.89, ranges: [71, 52, 34, 18] },
      ],
    },
  },
  chargeDemo: {
    ariaLabel:
      "Exemplo ilustrativo: a Fidexa envia o lembrete de uma parcela pelo WhatsApp, o cliente paga pelo Pix, a cobrança vira paga e as próximas etapas da régua deixam de ser necessárias.",
    storeName: "Calçados Bela Vista",
    storeInitials: "BV",
    businessAccount: "Conta comercial",
    typing: "digitando…",
    today: "Hoje",
    statusOpen: "Em aberto",
    statusPaid: "Pago",
    chargeTitle: "Parcela 3 de 6",
    chargeValue: "R$ 189,90",
    chargeWho: "Juliana Santos · vence em",
    chargeDue: "15/10",
    rangesLabel: "Régua de cobrança",
    steps: [
      {
        title: "Lembrete antes do vencimento",
        scheduled: "Agendado",
        date: "12/10",
      },
      {
        title: "Aviso no dia do vencimento",
        scheduled: "Agendado",
        date: "15/10",
      },
      {
        title: "Cobrança com 5 dias de atraso",
        scheduled: "Agendada",
        date: "20/10",
      },
      {
        title: "Cobrança com 15 dias de atraso",
        scheduled: "Agendada",
        date: "30/10",
      },
    ],
    stateSent: "Enviado",
    stateSkipped: "Não necessário",
    reminderLine1: "Oi, Juliana! Sua parcela de",
    reminderValue: "R$ 189,90",
    reminderLine1End: "vence em",
    reminderDate: "15/10",
    reminderLine2: "Para pagar pelo Pix, é só abrir:",
    reminderLink: "pagar.exemplo.com.br/8K2Q",
    reply: "Paguei agora pelo Pix!",
    thanks: "Pagamento confirmado. Obrigado, Juliana!",
  },
  bigNumbers: {
    title: "Resultados que provam a recuperação",
    subtitle:
      "Números que mostram o impacto da Fidexa na cobrança e na recuperação de crédito do varejo brasileiro.",
    metrics: [
      "Mensagens de cobrança enviadas",
      "Acordos de pagamento fechados",
      "Taxa média de recuperação da carteira",
      "Taxa de leitura das mensagens no WhatsApp",
    ],
  },
  marquee: {
    phrases: [
      "Clareza pra cobrar",
      "Liberdade pra recuperar",
      "Menos inadimplência",
      "Revolucionando o mercado de cobrança",
    ],
  },
  // Faixa laranja "WhatsApp bloqueado" da home. Fatos: "parceira Meta",
  // "API oficial do WhatsApp", "segurança e alta entregabilidade" (site) e
  // "conformidade com o modelo de template" (PEGN, 27/08/2026) — ver
  // .claude/skills/seo/reference/fidexa-empresa.md §3 e §6.
  manualVsAutomation: {
    title: "Cobrança manual Vs Automação",
    caption: "Comparativo entre cobrança manual e automação com a Fidexa",
    columns: [
      { key: "manual", label: "Cobrança manual" },
      { key: "fidexa", label: "Com a Fidexa", highlight: true },
    ],
    rows: [
      {
        label: "Quem acompanha os vencimentos",
        cells: {
          manual: "Alguém da loja, na planilha",
          fidexa: "A régua automática",
        },
      },
      {
        label: "Como o cliente recebe a cobrança",
        cells: {
          manual: "Quando sobra tempo para mandar",
          fidexa: "No WhatsApp, antes, no dia e depois do vencimento",
        },
      },
      {
        label: "Como o cliente paga",
        cells: {
          manual: "Pede os dados e envia o comprovante",
          fidexa: "Escolhe a parcela e paga por Pix na conversa",
        },
      },
      {
        label: "Quem dá baixa",
        cells: {
          manual: "Alguém confere a conta e lança no sistema",
          fidexa: "Baixa automática",
        },
      },
      {
        label: "Onde a equipe negocia",
        cells: {
          manual: "No celular de cada loja",
          fidexa: "No chat unificado",
        },
      },
      {
        label: "Carteira de várias lojas",
        cells: { manual: false, fidexa: "Painel único" },
      },
      {
        label: "Dívida pequena ou já negativada",
        cells: {
          manual: "Costuma ficar para trás",
          fidexa: "Entra na cobrança, de qualquer valor",
        },
      },
    ],
  },
  whatsappBlocked: {
    eyebrow: "Cobrança pela API oficial do WhatsApp",
    title: "Não quer mais ter o WhatsApp da loja bloqueado por cobrança?",
    description:
      "A Fidexa é parceira Meta e cobra pela API oficial do WhatsApp, com mensagens no modelo de template aprovado pela Meta. Sua loja deixa de cobrar pelo número pessoal e passa a ter segurança e alta entregabilidade.",
    cta: "Falar com a Fidexa",
    ctaNote: "Demonstração gratuita com um especialista",
    imageAlt:
      "Celular com a tela do WhatsApp mostrando o aviso 'Esta conta não pode usar o WhatsApp', exibido quando um número é bloqueado por violar os Termos de Serviço",
  },
  // Depoimentos do perfil da Fidexa no Google (constants/googleReviews.ts).
  googleReviews: {
    ratingLabel: "Nota no Google:",
    onGoogle: "no Google",
    reviews: "avaliações",
    title: "Quem já cobra com a Fidexa recomenda",
    subtitle:
      "Avaliações públicas de lojistas e parceiros no perfil da Fidexa no Google, no texto original de quem escreveu.",
    sourcePrefix: "Avaliação no Google",
  },
  meta: {
    partnersPrefix: "Somos parceiros ",
    partnersBrand: "Meta",
    subtitle:
      "A Fidexa é parceira Meta e utiliza a API oficial do WhatsApp para automação de cobrança com segurança e alta entregabilidade.",
  },
  faq: {
    heading: "Perguntas Frequentes",
    items: [
      {
        question: "O que é a Fidexa?",
        answer:
          "A Fidexa é uma plataforma de cobrança via WhatsApp e gestão de crediário para o varejo brasileiro. Ela automatiza sua régua de cobrança, recupera créditos em atraso e reduz a inadimplência com mensagens personalizadas, mantendo uma relação próxima e amigável com seus clientes.",
      },
      {
        question: "Para quem é a Fidexa?",
        answer:
          "A Fidexa é feita para lojistas e redes de varejo que trabalham com crediário próprio e precisam organizar a cobrança. Atendemos desde a loja única até redes com várias unidades, centralizando a cobrança e o atendimento de todas as lojas em um só lugar.",
      },
      {
        question: "Como funciona a cobrança via WhatsApp?",
        answer:
          "Você configura uma régua de cobrança e a Fidexa envia mensagens automáticas e personalizadas no momento certo — antes, no vencimento e após o atraso. Tudo acontece em um chat unificado, onde sua equipe acompanha as conversas, separa o atendimento por loja e mede a conversão das cobranças.",
      },
      {
        question: "A Fidexa realmente reduz a inadimplência?",
        answer:
          "Sim. Com mensagens automáticas e personalizadas, as Lojas Elder reduziram a inadimplência de 14% para 8% usando a Fidexa, recuperando clientes e diminuindo atrasos sem aumentar os custos operacionais da equipe financeira.",
      },
      {
        question: "Preciso trocar de sistema para usar a Fidexa?",
        answer:
          "Não. A Fidexa funciona ao lado do que você já usa. É possível importar sua base de clientes e parcelas por planilha e começar a cobrar rapidamente, sem precisar substituir o seu sistema de gestão atual.",
      },
      {
        question: "A Fidexa é segura e está em conformidade com a LGPD?",
        answer:
          "Sim. A segurança e a privacidade dos dados são prioridade na Fidexa. A plataforma segue as diretrizes da LGPD no tratamento das informações dos seus clientes, com acesso controlado e dados protegidos.",
      },
      {
        question: "Quanto custa a Fidexa?",
        answer:
          "O valor é definido conforme o tamanho da sua operação e a quantidade de lojas. Solicite uma demonstração gratuita e nossos especialistas montam uma proposta sob medida para a sua realidade.",
      },
      {
        question: "Como começo a usar a Fidexa?",
        answer:
          "É simples: agende uma demonstração com nosso time. Mostramos a plataforma na prática, ajudamos na configuração da régua de cobrança e fazemos o onboarding da sua equipe para você começar a recuperar créditos o quanto antes.",
      },
    ],
  },
  footer: {
    tagline: [
      "Clareza pra cobrar.",
      "Liberdade pra recuperar.",
      "Faça Fidexa. Agende uma demo.",
    ],
    productsTitle: "Produtos",
    products: [
      {
        title: "Cobrança via WhatsApp",
        desc: "Automatize sua régua de cobrança",
      },
      {
        title: "Recuperação de Crédito",
        desc: "Recupere dívidas com eficiência",
      },
      { title: "Gestão de Crediário", desc: "Controle total do seu crediário" },
      {
        title: "Régua Automatizada",
        desc: "Mensagens personalizadas na hora certa",
      },
      {
        title: "Chat Centralizado",
        desc: "Atendimento do seu time em um só lugar",
      },
    ],
    othersTitle: "Outros",
    others: ["Quem Somos", "Canais de Atendimento", "Central de Ajuda"],
    legalTitle: "Legal",
    legal:
      "FIDEXA SERVIÇOS DE CRÉDITO LTDA — CNPJ 63.161.339/0001-90. Segurança em primeiro lugar, feito com dedicação para o varejo brasileiro. Pra cima!",
    rights: "Todos os direitos reservados.",
  },
  cookies: {
    text: "Usamos cookies para entender como você navega e melhorar sua experiência na Fidexa. Você pode aceitar ou recusar os cookies de análise e marketing.",
    accept: "Aceitar",
    decline: "Recusar",
  },
  whatsapp: {
    floatAria: "Contatar via WhatsApp",
  },
};
